import PropTypes from 'prop-types';
import React from 'react';

function MyStableIcon({title, subText, className}) {
  return (
    <div className={["my-stable-icon", className].join(' ')}>
      <svg viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>{title}</title>
        <g fillRule="evenodd">
          <g transform="translate(-1465.000000, -366.000000)">
            <g transform="translate(1365.000000, 35.000000)">
              <g id="Group-17" transform="translate(100.000000, 331.000000)">
                <g id="Group-16">
                  <path d="M39.9909767,62.9941812 C37.4367343,63.6507989 34.7591473,64 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 C48.5612214,0 62.1840242,12.580866 63.8326083,28.7067979 C60.3293247,25.2262267 47.1771766,12.7370076 36.5745081,10.3839888 C24.2282843,7.64402799 31.2618151,9.26129692 31.2618151,9.26129692 L26.3714618,6.64631779 L27.3040195,11.4135893 L22.7776391,8.29615168 L25.3425005,14.0611334 L22.3551936,19.1720627 L25.2119949,19.5807551 L11,42.3569235 L12.3201396,44.6504203 L15.323736,46.5456141 L19.6191665,44.0282345 L17.0643537,46.4993819 L20.119103,46.4993819 L22.1829279,44.9234283 L26.1829279,40.0607994 L31.1214724,36.3602491 C31.1214724,36.3602491 43.541829,54.0583566 39.9909767,62.9941812 Z" id="Combined-Shape"/>
                  <path d="M56.8413589,52.1735629 C57.8803558,50.8957236 58.8227328,49.5361712 59.6573595,48.106036 L58.7978304,44.0979619 L53.683432,33.3431953 L45.1824458,22.9201183 L38,18 L42.3218277,22.4092702 L49.5335306,32.773833 L54.6186719,43.5295858 L56.8413589,52.1735629 Z" id="Combined-Shape"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <span>{subText}</span>
    </div>
  );
}

MyStableIcon.propTypes = {
  title: PropTypes.string.isRequired,
  subText: PropTypes.string,
  className: PropTypes.string
}

export default MyStableIcon



// WEBPACK FOOTER //
// ./modules/Common/components/svg/MyStableIcon.js